export default {
  COUPONS: "कूपन्स",
  COUPON: "कूपन",
  CREATECOUPONS: "कूपन बनाएं",
};
